import React, { Fragment } from 'react'
import {
    IconButton,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Icon,
    TablePagination,
} from '@material-ui/core';

const GetIconReceipt = ({type}) => {

    let iconReturn = GetIcons('warning','primary');

    switch (type) {
        case 1: iconReturn = GetIcons('location_on',0); break;
        case 2: iconReturn = GetIcons('local_shipping',1);  break;
        case "delivery": iconReturn = GetIcons('local_shipping',1);  break;
        case "pickup": iconReturn = GetIcons('location_on',0);  break;
        case "Delivery": iconReturn = GetIcons('local_shipping',1);  break;
        case "Pickup": iconReturn = GetIcons('location_on',0);  break;
        case "dilivery": iconReturn = GetIcons('local_shipping',1);  break;
        case "Dilivery": iconReturn = GetIcons('local_shipping',1);  break;
        case "1": iconReturn = GetIcons('location_on',0);  break;
        case "2": iconReturn = GetIcons('local_shipping',0);  break;
        default: iconReturn = GetIcons('warning',1);
    }

    return iconReturn;
};

const GetIcons = (name,color) => {

    let colorAr = [
        '#3dc1d3',
        '#e15f41'
    ]

    return <IconButton >
        <Icon style={{color:colorAr[color],fontSize:32}}>{name}</Icon>
    </IconButton>;
};



export default GetIconReceipt;